/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetShiftLeadsQueryVariables = Types.Exact<{
  where?: Types.Maybe<Types.UserWhereInput>;
  take?: Types.Maybe<Types.Scalars["Int"]>;
}>;

export type GetShiftLeadsQuery = {
  users: Array<Pick<Types.User, "id" | "name" | "email">>;
};

export const GetShiftLeadsDocument = gql`
  query GetShiftLeads($where: UserWhereInput, $take: Int) {
    users(where: $where, take: $take) {
      id
      name
      email
    }
  }
`;

/**
 * __useGetShiftLeadsQuery__
 *
 * To run a query within a React component, call `useGetShiftLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftLeadsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetShiftLeadsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetShiftLeadsQuery,
    GetShiftLeadsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetShiftLeadsQuery,
    GetShiftLeadsQueryVariables
  >(GetShiftLeadsDocument, baseOptions);
}
export function useGetShiftLeadsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetShiftLeadsQuery,
    GetShiftLeadsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetShiftLeadsQuery,
    GetShiftLeadsQueryVariables
  >(GetShiftLeadsDocument, baseOptions);
}
export type GetShiftLeadsQueryHookResult = ReturnType<
  typeof useGetShiftLeadsQuery
>;
export type GetShiftLeadsLazyQueryHookResult = ReturnType<
  typeof useGetShiftLeadsLazyQuery
>;
export type GetShiftLeadsQueryResult = ApolloReactCommon.QueryResult<
  GetShiftLeadsQuery,
  GetShiftLeadsQueryVariables
>;
